import {styled} from '@linaria/react';
import React, {SyntheticEvent, useCallback, useState} from 'react';
import {Icon, IconSize} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {ModalDialog} from '../../atoms/ModalDialog/ModalDialog';
import {
  TermsAndConditionsBody,
  TermsAndConditionsHeader,
} from '../../atoms/TermsAndConditions/TermsAndConditions';

interface InfoCircleWithDialogProps {
  header?: string;
  conditions?: string;
  position?: 'right' | 'left';
  infoIconVariant?: 'filled' | 'hollow';
  toggleClick?: (state: boolean) => void;
  className?: string;
  dataTestid?: string;
  fill?: string;
  iconSize?: keyof typeof IconSize;
}

export const InfoCircleWithDialog: React.FC<InfoCircleWithDialogProps> = ({
  header,
  conditions,
  className,
  toggleClick,
  infoIconVariant = 'filled',
  position = 'right',
  dataTestid = 'infoCircleWithDialog',
  fill,
  iconSize,
}) => {
  const [showModal, setShowModal] = useState(false);

  const open = useCallback((e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
    toggleClick?.(true);
  }, []);

  const close = useCallback(() => {
    setShowModal(false);
    toggleClick?.(false);
  }, []);

  const assets =
    infoIconVariant === 'filled'
      ? GenericIconName.InfoFilled
      : GenericIconName.Info;

  return (
    <>
      <ModalDialog
        open={showModal}
        onClose={close}
        showCloseIcon
        showHeaderDivider
        headerContent={
          <TermsAndConditionsHeader>{header}</TermsAndConditionsHeader>
        }
        bodyContent={
          <TermsAndConditionsBody>{conditions}</TermsAndConditionsBody>
        }
        renderInPortal
      />

      <StyledIcon
        asset={
          infoIconVariant === 'filled' && fill
            ? GenericIconName.InfoWithoutFill
            : assets
        }
        size={iconSize || 'XS'}
        onClick={open}
        className={className}
        data-testid={dataTestid}
        data-position={position}
        fill={fill}
      />
    </>
  );
};

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 0.625rem;
  left: 0.625rem;
  cursor: pointer;

  &[data-position='right'] {
    top: 0.313rem;
    right: 0.313rem;
    left: unset;
  }
`;
